import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useFormContext } from 'react-hook-form';
import { SiemProtocol } from '@kirin/api-client/contracts/settings';
import { siemProtocolDefaultPort, siemProtocolLabelMap } from './constants';
import type { SiemFormValues } from './types';

interface TransportProtocolFieldProps {
  onSensitiveChange?: () => void;
}

export function TransportProtocolField({
  onSensitiveChange,
}: TransportProtocolFieldProps) {
  const { watch, setValue } = useFormContext<SiemFormValues>();
  const protocol = watch('protocol');

  const handleProtocolChange = (value: SiemFormValues['protocol']) => {
    onSensitiveChange?.();
    setValue('protocol', value, { shouldDirty: true, shouldValidate: true });
    setValue('port', siemProtocolDefaultPort[value], {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <div className="space-y-2">
      <Label className="text-sm font-semibold text-foreground">
        Transport Protocol
      </Label>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <Input
            id="siem-protocol-tcp"
            type="radio"
            name="siem-protocol"
            value={SiemProtocol.Tcp}
            checked={protocol === SiemProtocol.Tcp}
            onChange={() => handleProtocolChange(SiemProtocol.Tcp)}
            className="h-4 w-4 rounded-full border border-input text-destructive accent-destructive focus-visible:ring-[3px] focus-visible:ring-ring/50"
          />
          <Label
            htmlFor="siem-protocol-tcp"
            className="text-sm text-primary font-semibold"
          >
            {siemProtocolLabelMap[SiemProtocol.Tcp]}{' '}
            <span className="font-normal text-foreground/80">
              (default port {siemProtocolDefaultPort[SiemProtocol.Tcp]})
            </span>
          </Label>
        </div>
        <div className="flex items-center gap-2">
          <Input
            id="siem-protocol-udp"
            type="radio"
            name="siem-protocol"
            value={SiemProtocol.Udp}
            checked={protocol === SiemProtocol.Udp}
            onChange={() => handleProtocolChange(SiemProtocol.Udp)}
            className="h-4 w-4 rounded-full border border-input text-destructive accent-destructive focus-visible:ring-[3px] focus-visible:ring-ring/50"
          />
          <Label
            htmlFor="siem-protocol-udp"
            className="text-sm text-primary font-semibold"
          >
            {siemProtocolLabelMap[SiemProtocol.Udp]}{' '}
            <span className="font-normal text-foreground/80">
              (default port {siemProtocolDefaultPort[SiemProtocol.Udp]})
            </span>
          </Label>
        </div>
        <div className="flex items-center gap-2">
          <Input
            id="siem-protocol-hec"
            type="radio"
            name="siem-protocol"
            value={SiemProtocol.Hec}
            checked={protocol === SiemProtocol.Hec}
            onChange={() => handleProtocolChange(SiemProtocol.Hec)}
            className="h-4 w-4 rounded-full border border-input text-destructive accent-destructive focus-visible:ring-[3px] focus-visible:ring-ring/50"
          />
          <Label
            htmlFor="siem-protocol-hec"
            className="text-sm text-primary font-semibold"
          >
            {siemProtocolLabelMap[SiemProtocol.Hec]}{' '}
            <span className="font-normal text-foreground/80">
              (Splunk HTTP Event Collector)
            </span>
          </Label>
        </div>
      </div>
    </div>
  );
}
